export default "__VITE_ASSET__3854648a__"